// extracted by mini-css-extract-plugin
export default {"modalOverlay":"MA-z","modalContent":"NA-z","header":"OA-z","close":"PA-z"};